import styled from '@emotion/styled';
import { Button } from 'antd';
import tw from 'twin.macro';

export const CustomButtonGroupButton = styled(Button)`
    box-shadow: none !important;
    height: 100% !important;
    display: flex;
    align-items: center;
    &:hover:not(:disabled) {
        ${tw`border-purpleFont text-headerColor`}
    }
`;
